/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_Payment_Method_Bank_TransferInputs */

const vi_expense_payment_method_bank_transfer = /** @type {(inputs: Expense_Payment_Method_Bank_TransferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chuyển khoản`)
};

/**

* @param {Expense_Payment_Method_Bank_TransferInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_payment_method_bank_transfer = /** @type {((inputs?: Expense_Payment_Method_Bank_TransferInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_Payment_Method_Bank_TransferInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_payment_method_bank_transfer(inputs)
});